export const errorMsgs = {
  STAKEHOLDER_ERROR: "Check list is not available for this stakeholder.",
  STAKEHOLDERS_CHECKLIST_ERROR: "Stakeholder check list is not available.",
  COMPANY_CHECKLIST_ERROR: "Company check list is not available."
};

export const titles = {
  COMPANY_TITLE: "Company",
  STAKEHOLDER_TITLE: "Stakeholder",
  COMPANY_ADDITIONAL_INFO: "Company Additional Info",
  CHECK_NAME_TITLE: "Check Name",
  STATUS_TITLE: "Status",
  RESULT_REASON_TITLE: "Result/ Reason"
};
